// VanJS Feather - Home
import van from "vanjs-core";
import { FeatherIcon, svgNamespace } from "../FeatherIcon.ts";
import { type SVGProps } from "../types.ts";

export const Home = (props: Partial<SVGProps> = {}) => {
  const { path, polyline } = van.tags(svgNamespace);

  return FeatherIcon(
    props,
    path({ "d": "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" }),
    polyline({ points: "9 22 9 12 15 12 15 22" }),
  );
};
